<template>
<div id="cookie-alert">
  <div id="cookie-header">
    <div id="cookie-icon"></div>
    <span>Pliki Cookie</span>
  </div>
  <div id="cookie-content">
    <span>Korzystając z tej strony zgadzasz się na korzystanie z ciasteczek.</span>
    <br>
    <a href="http://wszystkoociasteczkach.pl/">Dowiedz się więcej.</a>
  </div>
  <div id="cookie-button" @click="handleClick">Zamknij</div>
</div>
</template>

<script>
import Vue from 'vue';
import VueCookies from 'vue-cookies';

VueCookies.config('30d');
Vue.use(VueCookies);

export default {
  name: 'CookieAlert',
  methods: {
    handleClick() {
      this.$cookies.set('agree', true);
      this.$emit('cookieStatus');
    },
  },
};
</script>

<style scoped lang="scss">
  @keyframes cookieFadeIn {
    from { opacity: 0; transform: translateY(100%) }
    to { opacity: 1; transform: translateY(0) }
  }

  #cookie-alert {
    position: fixed;
    bottom: 5px;
    right: 5px;

    width: calc(100% - 10px);
    overflow: hidden;
    height: 150px;
    padding: 15px;
    border-radius: 4px;
    box-shadow: 0 0 2px black;

    background-color: white;
    color: black;
    font-family: Arial, sans-serif;

    animation: cookieFadeIn .7s both;

    z-index: 8;

    @media (min-width: 576px) { width: 450px; }
    @media (min-width: 992px) { right: 15px; bottom: 15px; }
  }

  #cookie-icon {
    background-image: url("../assets/cookie.png");
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    width: 30px; height: 30px;
  }

  #cookie-header {
    display: flex;
    align-items: center;

    position: relative;
    height: 30px; width: 100%;

    font-weight: bold;
    font-size: 1.3em;

    span { padding: 0 10px }
  }

  #cookie-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 14px;

    padding: 5px;

    a {
      padding: 0; margin: 0;
      color: #009c1a;
      text-decoration: underline;
      font-weight: bold;
      width: 150px;
    }
  }

  #cookie-button {
    position: absolute;
    right: 5px; bottom: 5px;

    width: 100px; height: 28px;
    border-radius: 4px;
    padding: 6px 0 0 0;

    color: white;
    background-color: #009c1a;

    cursor: pointer;
    font-weight: bold;
    text-align: center;

    transition: background-color .25s;

    &:hover { background-color: #006c1a; }
  }
</style>
